<template>
  <div class="report-params">
    <div class="tip">
      <i class="iconfont icon-icontychatbubble icon-chat"/>
      <div style="display: flex;">
        <span>注意：等级参数设置的修改会关联并影响本次考试内的所有科目。</span>
        <div class='include-div'>
          <el-checkbox :disabled="disableLevelScore" v-model="levelScoreParam.levelFlag">开启等级分</el-checkbox>
          <el-switch
            v-model="levelScoreParam.levelType"
            :disabled="!levelScoreParam.levelFlag"
            active-value="1"
            inactive-value="0"
            active-color="#469064"
            active-text="人数比例"
            inactive-text="分数比例">
          </el-switch>
          <el-checkbox :disabled="!levelScoreParam.levelFlag" v-model="levelScoreParam.scoreFlag">包含原始分</el-checkbox>
        </div>
      </div>
    </div>
    <div class="content-wrap">
      <div class="score-level-container">
        <div class="score-wrap">
          <span>科目总分：{{totalScore}}</span>
        </div>
        <!--分文理-->
        <el-form v-if="wenLiInput" class="score-level-form" :model="levelScoreParam" ref="scoreLevelFormWenLi">
          <div class="score-level-item-wrap left">
            <span>文科考生参数：</span>
            <div class="level-wrap" v-for="(levelData, levelIndex) in levelScoreParam.levelsDataWen" :key="levelIndex" >
              <el-form-item :prop="'levelsDataWen.'+levelIndex+'.levelName'" class="score-level-name"
              :rules="[{ required: true, message: '等级名称不能为空', trigger: 'blur' }]">
                <el-input :disabled="!levelScoreParam.levelFlag" v-model="levelData.levelName" size="mini"/>&ensp;
                <span>档：>=&ensp;{{ gradeTypeText }}*</span>
              </el-form-item>
              <el-form-item :prop="'levelsDataWen.'+levelIndex+'.percent'" class="score-level-percent" :rules="levelRules">
                <el-input
                  :disabled="levelIndex === levelScoreParam.levelsDataWen.length - 1 || !levelScoreParam.levelFlag"
                  v-model="levelData.percent"
                  size="mini"/>&ensp;%
                <span v-if="levelIndex===0"> <&ensp;{{ gradeTypeText }}&ensp;</span>
                <span v-else> <&ensp;{{ gradeTypeText }}*{{levelScoreParam.levelsDataWen[levelIndex-1].percent}}%&ensp;</span>
                <template v-if="levelScoreParam.levelType === '0'">
                  <span v-if="levelIndex === 0">{{`${totalScore*levelData.percent/100}分-${totalScore}分`}}</span>
                  <span v-else>{{`${totalScore*levelData.percent/100}分-${totalScore*levelScoreParam.levelsDataWen[levelIndex-1].percent/100}分`}}</span>
                </template>
              </el-form-item>
              <div v-if="levelIndex < levelScoreParam.levelsDataWen.length - 1 && levelScoreParam.levelFlag" class="operate-wrap">
                <i @click="addLevel(levelIndex,'levelsDataWen')" class="el-icon-circle-plus-outline add-sub-item"></i>
                <i @click="removeLevel(levelIndex,'levelsDataWen')" v-show="levelIndex>0" class="el-icon-remove-outline remove-sub-item"></i>
              </div>
            </div>
          </div>
          <div class="score-level-item-wrap right">
            <span>理科考生参数：</span>
            <div class="level-wrap" v-for="(levelData, levelIndex) in levelScoreParam.levelsDataLi" :key="levelIndex" >
              <el-form-item :prop="'levelsDataLi.'+levelIndex+'.levelName'" class="score-level-name"
              :rules="[{ required: true, message: '等级名称不能为空', trigger: 'blur' }]">
                <el-input :disabled="!levelScoreParam.levelFlag" v-model="levelData.levelName" size="mini"/>&ensp;
                <span>档：>=&ensp;{{ gradeTypeText }}*</span>
              </el-form-item>
              <el-form-item :prop="'levelsDataLi.'+levelIndex+'.percent'" class="score-level-percent"
              :rules="levelRules">
                <el-input :disabled="levelIndex === levelScoreParam.levelsDataLi.length - 1 || !levelScoreParam.levelFlag"  v-model="levelData.percent" size="mini"/>&ensp;%
                <span v-if="levelIndex===0"> <&ensp;{{ gradeTypeText }}&ensp;</span>
                <span v-else> <&ensp;{{ gradeTypeText }}*{{levelScoreParam.levelsDataLi[levelIndex-1].percent}}%&ensp;</span>
                <template v-if="levelScoreParam.levelType === '0'">
                  <span v-if="levelIndex === 0">{{`${totalScore*levelData.percent/100}分-${totalScore}分`}}</span>
                  <span v-else>{{`${totalScore*levelData.percent/100}分-${totalScore*levelScoreParam.levelsDataLi[levelIndex-1].percent/100}分`}}</span>
                </template>
              </el-form-item>
              <div v-if="levelIndex < levelScoreParam.levelsDataLi.length - 1 && levelScoreParam.levelFlag" class="operate-wrap">
                <i @click="addLevel(levelIndex,'levelsDataLi')" class="el-icon-circle-plus-outline add-sub-item"></i>
                <i @click="removeLevel(levelIndex,'levelsDataLi')" v-show="levelIndex>0" class="el-icon-remove-outline remove-sub-item"></i>
              </div>
            </div>
          </div>
        </el-form>
        <!--不分文理-->
        <el-form v-else class="score-level-form" :model="levelScoreParam" ref="scoreLevelForm">
          <div class="score-level-item-wrap">
            <div class="level-wrap" v-for="(levelData, levelIndex) in levelScoreParam.levelsData" :key="levelIndex" >
              <el-form-item :prop="'levelsData.'+levelIndex+'.levelName'" class="score-level-name"
              :rules="[{ required: true, message: '等级名称不能为空', trigger: 'blur' }]">
                <el-input :disabled="!levelScoreParam.levelFlag" v-model="levelData.levelName" size="mini"/>&ensp;
                <span>档：>=&ensp;{{ gradeTypeText }}*</span>
              </el-form-item>
              <el-form-item :prop="'levelsData.'+levelIndex+'.percent'" class="score-level-percent" :rules="levelRules">
                <el-input  :disabled="levelIndex === levelScoreParam.levelsData.length - 1 || !levelScoreParam.levelFlag" v-model.number="levelData.percent" size="mini"/>&ensp;%
                <span v-if="levelIndex>0"> <&ensp;{{ gradeTypeText }}*{{levelScoreParam.levelsData[levelIndex-1].percent}}%&ensp;</span>
                <template v-if="levelScoreParam.levelType === '0'">
                  <span v-if="levelIndex === 0">{{`${totalScore*levelData.percent/100}分-${totalScore}分`}}</span>
                  <span v-else>{{`${totalScore*levelData.percent/100}分-${totalScore*levelScoreParam.levelsData[levelIndex-1].percent/100}分`}}</span>
                </template>
              </el-form-item>
              <div v-if="levelIndex < levelScoreParam.levelsData.length - 1 && levelScoreParam.levelFlag" class="operate-wrap">
                <i @click="addLevel(levelIndex)" class="el-icon-circle-plus-outline add-sub-item"></i>
                <i @click="removeLevel(levelIndex)" v-show="levelIndex>0" class="el-icon-remove-outline remove-sub-item"></i>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// 引入图片地址

import common from '@/util/common'
import _ from 'lodash'

export default {
  data () {
    return {
      levelScoreParam: {
        levelType: 0,
        levelFlag: false, // 显示等级
        scoreFlag: true, // 显示原始分
        levelsData: [{
          levelName: 'A',
          percent: 85
        }, {
          levelName: 'B',
          percent: 60
        }, {
          levelName: 'C',
          percent: 25
        }, {
          levelName: 'D',
          percent: 2
        }, {
          levelName: 'E',
          percent: 0
        }],
        levelsDataWen: [{
          levelName: 'A',
          percent: 85
        }, {
          levelName: 'B',
          percent: 60
        }, {
          levelName: 'C',
          percent: 25
        }, {
          levelName: 'D',
          percent: 2
        }, {
          levelName: 'E',
          percent: 0
        }],
        levelsDataLi: [{
          levelName: 'A',
          percent: 85
        }, {
          levelName: 'B',
          percent: 60
        }, {
          levelName: 'C',
          percent: 25
        }, {
          levelName: 'D',
          percent: 2
        }, {
          levelName: 'E',
          percent: 0
        }]
      },
      levelRules: [
        {
          required: true,
          message: '比例不能为空'
        },
        {
          pattern: /^100$|^(\d|[1-9]\d)$/,
          message: '必须是不大于100的正整数',
          trigger: 'blur'
        },
        {
          validator: (rule, value, callback) => {
            console.log(this)
            let tempCount = 0
            for (let level of this.levelScoreParam.levelsData) {
              if (level.percent === value) {
                tempCount++
              }
            }
            console.log(tempCount)
            if (tempCount > 1) {
              callback(new Error('等级值不能重复'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }
      ]
    }
  },
  props: {
    enableScoreLevel: {
      type: Boolean,
      default: true
    },
    wenLiFlag: {
      type: Boolean,
      default: true
    },
    wenLiFlagText: {
      type: String,
      default: 'none'
    },
    scoreLevel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    totalScore: {
      type: Number,
      required: true,
      default: 0
    },
    configParam: {
      type: Object,
      default: () => {
        return {
          gradeType: 0, // 0：分数比例，1：人数比例
          gradeFlag: true, // 显示等级
          scoreFlag: true, // 显示原始分
          levelsDataExist: {} // 等级数据
        }
      }
    }
  },
  computed: {
    disableLevelScore () {
      if (this.enableScoreLevel) {
        return false
      } else {
        return true
      }
    },
    gradeTypeText () {
      return this.levelScoreParam.levelType.toString() === '0' ? '满分' : '排名数'
    },
    wenLiInput () {
      let res = false
      if (this.wenLiFlag) {
        if (this.wenLiFlagText === 'none') {
          res = true
        }
      }
      return res
    }
  },
  methods: {
    /**
     * 新增级别
     * @return
     */
    addLevel (index, wenliKey) {
      if (wenliKey) {
        this.levelScoreParam[wenliKey].splice(index + 1, 0, {
          levelName: '',
          percent: 0
        })
      } else {
        this.levelScoreParam.levelsData.splice(index + 1, 0, {
          levelName: '',
          percent: 0
        })
      }
    },
    /**
     * 移除级别
     * @return
     */
    removeLevel (index, wenliKey) {
      if (wenliKey) {
        this.levelScoreParam[wenliKey].splice(index, 1)
      } else {
        this.levelScoreParam.levelsData.splice(index, 1)
      }
    },
    /**
     * 获取分数段设置 -- 供给父组件调用
     * @return [object] scoreSection
     */
    fetchScoreLevel () {
      console.log(this.levelScoreParam)
      let promise = this.$refs.scoreLevelForm.validate()

      return promise.then(valid => {
        if (valid) {
          if (this.compare()) {
            return this.levelScoreParam
          }
        }
      })
    },
    /**
     * 比较参数
     * 1.百分比递减
     * @return [boolean] flag 参数比较结果
     */
    compare () {
      console.log('compare')
      let result = true
      for (let levelIndex in this.levelScoreParam.levelsData) {
        if (levelIndex > 0 && levelIndex < this.levelScoreParam.levelsData.length - 1) {
          let currentPercent = parseFloat(this.levelScoreParam.levelsData[levelIndex].percent)
          let brePercent = parseFloat(this.levelScoreParam.levelsData[levelIndex - 1].percent)
          console.log(currentPercent, brePercent)
          if (currentPercent >= brePercent) {
            this.alertError('等级百分比的值不能相同，并且需要从上向下递减')
            result = false
          }
        }
      }
      return result
    },
    // 还原参数设置
    recoverConfig () {
      this.levelScoreParam.levelType = this.configParam.gradeType.toString()
      this.levelScoreParam.levelFlag = this.configParam.gradeFlag // 显示等级
      this.levelScoreParam.scoreFlag = this.configParam.scoreFlag // 显示原始分
      console.log('recoverConfig', this.configParam)
      if (this.configParam.levelsDataExist.gradeParamArray) {
        this.levelScoreParam.levelsData.splice(0, this.levelScoreParam.levelsData.length)
        for (let level of this.configParam.levelsDataExist.gradeParamArray) {
          this.levelScoreParam.levelsData.push({
            levelName: level.segmentKey,
            percent: level.segmentValue.split(',')[0].replace('[', '')
          })
        }
      }
    },
    // 错误弹窗
    alertError (errorMsg) {
      const h = this.$createElement
      let tipEls = [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--warning`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--warning']
        }, errorMsg)
      ]
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, tipEls)
      this.$alert(vnode, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        showCancelButton: false,
        confirmButtonClass: 'kw-alert__confirm-button kw-alert__confirm-button--success'
      })
    },
    checkResult () {
    },
    handleClose (done) {
      // 不调用 done, 而应该让父组件去关闭弹窗
      for (let splitItem of this.splitList) {
        splitItem.itemVisible = false
      }
      if (this.oprateStatus === 4) {
        this.oprateStatus = 0
        this.$emit('dialog-close')
      } else {
        this.oprateStatus = 0
        this.$emit('dialog-close', {examId: this.examId, operate: 'updateTaskMonitor'})
      }
    }
  },
  mounted () {
  },
  watch: {
  },
  created () {

  }
}
</script>
<style lang="scss" scoped>
.report-params {
  display: flex;
  align-items: center;
  flex-direction: column;
  .tip{
    display: flex;
    border: 1px solid $color-line;
    margin: 12px 0;
    padding: 6px 8px;
    font-size: 12px;
    line-height: 20px;
    width: 99%;
    box-sizing: border-box;

    /deep/ .el-switch__label * {
        font-size: 14px;
        font-weight:100;
    }
    .include-div {
      display: flex;
      align-items: center;
      /deep/ .el-checkbox {
        margin-right: 15px;
        margin-left: 15px;
      }
    }
  }

  .icon-chat{
    margin: 0 6px 0 2px;
    font-size: 20px;
  }

  .content-wrap{
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    width: 99%;
    .score-level-container {
      width: 100%;
      height: 420px;
      position: relative;
      border: 1px solid #d7d7d7;
      margin-top: 10px;
      padding: 10px 2%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .score-level-form {
        overflow: auto;
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      .score-level-item-wrap{
        width: 50%;
        &.left{
          margin-top: 15px;
        }
        &.right{
          margin-top: 10px;
        }
        .level-wrap{
          display: flex;
          height: 55px;
          .operate-wrap{
            display: flex;
            align-items: center;
          }
          .score-level-name{
            min-width: 135px;
          }
          .score-level-percent{
            min-width: 227px;
          }
        }
        .add-sub-item{
          font-size: 23px;
          color: $color-success;
          margin-left: 10px;
          cursor: pointer;
        }
        .remove-sub-item{
          font-size: 23px;
          color: $color-danger;
          margin-left: 10px;
          cursor: pointer;
        }
      }

      *{
        font-size: 12px;
      }

      .el-form-item__label{
        padding-right: 0;
      }

      .el-form-item{
        margin-bottom: 5px;
        white-space: nowrap;
      }

      .el-input{
        width: 35px;
      }

      .el-input__inner{
        padding: 0 2px;
      }

      .score-level-width{
        width: 32%;
      }

      .title{
        position: absolute;
        background: #fff;
        top: -12px;
        left: 20px;
        font-size: 14px;
      }

      .row{
        margin: 16px 0;
      }
    }
    *{
      font-size: 12px;
    }

    /deep/ .el-form-item__label{
      padding-right: 0;
    }

    /deep/ .el-form-item{
      margin-bottom: 5px;
      white-space: nowrap;
    }

    /deep/ .el-input{
      width: 35px;
    }

    /deep/ .el-input__inner{
      padding: 0 2px;
    }
  }

   /deep/ .el-form-item__label:before{
    display: none;
  }

  .has-rank{
    border: 1px solid #d7d7d7;
    padding: 6px 8px;
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exam/task/generate-subject-score/ScoreLevelParam.vue